export default __webpack_public_path__ + "static/media/content_tab03_1_01.9053a388.png";